import React, { useEffect } from 'react';
import { SalesPage } from './components/SalesPage';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel('1758908918422357');
    trackPageView();
  }, []);
  return <>
      <SalesPage data-id="element-0" />
    </>;
}